import { selectFeatureFlag } from '../../selectors/feature-flags';

export const getTrailersNewVersion = state => selectFeatureFlag(state, 'get-trailers-new-version');
